var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer"}},[_c('img',{staticClass:"logo-pisco",attrs:{"src":require("@/assets/LogoPiscoBlack.svg"),"alt":"Pisco Sistemas"}})])
}]

export { render, staticRenderFns }